import dayjs from "dayjs"
import Calendar from "../Calendar/Calendar"
import Dropdown from "../Dropdown/Dropdown"
import { DAYS, MONTHS, PAYMENT_SCHEDULE } from "../../config/consts"


export const Frequency = ({
  paymentSchedule,
  setPaymentSchedule,
  frequencyReadOnly = false,
  showFrequencyDropdown = true,
  hideStartDate = false,
  userRole,
}) => {
  const handleInputChange = ({ name, value }) => {
    let newValue = value

    if (name === "paymentDays" && Array.isArray(value)) {
      newValue = [...value].sort((a, b) => a - b)
    }

    if (frequencyReadOnly && name === 'frequency') {
      return
    }

    setPaymentSchedule((prev) => ({ ...prev, [name]: newValue }))
  }

  const disablePastDate = !(userRole === 'user' ||  userRole === 'customer')

  let frequencyTypes
  switch (paymentSchedule.frequency) {
    case 'weekly':
    case 'every2':
    case 'monthly':
      frequencyTypes = hideStartDate ? null : (
        <div className="flex-1">
          <Calendar
            disablePast={disablePastDate}
            label="Start Date"
            value={paymentSchedule.cycleStartDate}
            onChange={(e) => handleInputChange({ name: 'cycleStartDate', value: dayjs(e) })}
            isRequired={true}
            weekendsDisabled={false}
          />
        </div>
      )
      break
    case 'semiMonthly':
      frequencyTypes = (
        <div className="flex gap-6">
          {!hideStartDate && (
            <div className="flex-1">
              <Calendar
                disablePast={disablePastDate}
                label="First Start Date"
                value={paymentSchedule.cycleStartDate}
                onChange={(e) => handleInputChange({ name: 'cycleStartDate', value: e })}
                isRequired={true}
                weekendsDisabled={false}
              />
            </div>
          )}
          <div className="flex-1">
            <Calendar
              disablePast={disablePastDate}
              label="Second Start Date"
              value={paymentSchedule.secondDate}
              onChange={(e) => handleInputChange({ name: 'secondDate', value: dayjs(e) })}
              isRequired={true}
              weekendsDisabled={false}
            />
          </div>
        </div>
      )
      break
    case 'custom':
      frequencyTypes = (
        <div className="flex flex-row w-full gap-4">
          <Dropdown
            value={paymentSchedule.startFromMonth}
            setValue={(e) => handleInputChange({ name: 'startFromMonth', value: e })}
            menuItems={MONTHS}
            label="Start From Month"
            placeholder="Choose Month"
            className="w-full"
            variant="standard"
          />
          <Dropdown
            value={paymentSchedule.paymentDays || []}
            setValue={(e) => handleInputChange({ name: 'paymentDays', value: e })}
            menuItems={DAYS}
            label="Payment Days"
            placeholder="Choose Payment Days"
            className="w-full max-w-[350px]"
            variant="standard"
            isMulti={true}
          />
        </div>
      )
      break
  }

  return (
    <div className="w-full">
      {showFrequencyDropdown && (
        <div>
          <Dropdown
            value={paymentSchedule.frequency}
            setValue={(e) => handleInputChange({ name: 'frequency', value: e })}
            menuItems={PAYMENT_SCHEDULE}
            label="Frequency"
            placeholder="Choose Frequency"
            className="mt-6"
            variant="standard"
            disabled={frequencyReadOnly}
          />
        </div>
      )}
      <div className="mt-[24px]">
        {frequencyTypes}
      </div>
    </div>
  )
}